var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTheNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.463,
    height: 23.828,
    viewBox: "0 0 20.463 23.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "curve-arrow",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M36.45,6.955,43.1.3A1.011,1.011,0,1,1,44.53,1.726L39.593,6.669H49.716a6.915,6.915,0,0,1,6.9,6.882v9.266a1.01,1.01,0,1,1-2.021,0V13.554A4.89,4.89,0,0,0,49.716,8.69h-10.1l4.918,4.924A1.011,1.011,0,0,1,43.1,15.043L36.451,8.384A1.01,1.01,0,0,1,36.45,6.955Z",
    transform: "translate(-36.155 0)",
    fill: "#593a7c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTheNew);
export default __webpack_public_path__ + "static/media/arrowTheNew.5e81f530.svg";
export { ForwardRef as ReactComponent };